import React, { useState } from "react"
import styled from "styled-components"

import { Device } from "../../types/contentfulTypes"
import LoaderAnimation from "../animations/LoaderAnimation"
import PillButton from "../buttons/PillButton"

import CollectionList from "../lists/CollectionList"

interface Props {
  collections: Device[]
}

const CollectionsSection = (props: Props) => {
  const { collections } = props
  const [length, setLength] = useState(5)

  return (
    <Wrapper>
      <ContainerWrapper>
        {collections?.length > 0 ? (
          <>
            {collections?.slice(0, length).map((collection, index) => (
              <CollectionList collection={collection} key={index} />
            ))}
            {length < collections.length && (
              <PillButton title="View more" onClick={() => setLength(length + 5)} />
            )}
          </>
        ) : (
          <LoaderAnimation />
        )}
      </ContainerWrapper>
    </Wrapper>
  )
}

export default CollectionsSection

const Wrapper = styled.div`
  width: 100%;
  padding: 100px 0px 0;
`

const ContainerWrapper = styled.div`
  display: grid;
  max-width: 1234px;
  gap: 60px;
  margin: 0 auto;
`
